Measures the (tree shaken) size of a schema and validation defined with each library.

This will have a direct correlation with download time.
